import localStore from 'store';

export const removeElementSelection = (id) => localStore.remove(id);
